import { Box, Popover } from '@mui/material';
import React, { useMemo, useState } from 'react';
import { RgbColorPicker } from 'react-colorful';
import { actuatorControlPropTypes } from '../../types';
import { isValidRGB, parseXyToRgbValue, rgbToXy } from './utils';

const ColorRGBControl = ({ feature, value, handleChange }) => {
  return (
    <Box
      sx={{
        '.react-colorful': {
          width: '100px',
          height: '100px',
        },
      }}
    >
      <RgbColorPicker
        color={value}
        onChange={({ r, g, b }) =>
          handleChange(feature.property, rgbToXy(r, g, b))
        }
      />
    </Box>
  );
};

const ColorRGBControlWrapper = props => {
  const { mini, value } = props;

  const [anchorEl, setAnchorEl] = useState(null);

  const defaultValue = useMemo(() => {
    return isValidRGB(value) ? value : parseXyToRgbValue(value);
  }, [value]);

  const controlProps = { ...props, value: defaultValue };

  if (!mini) return <ColorRGBControl {...controlProps} />;

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <Box
        aria-describedby={id}
        sx={{
          backgroundColor: `rgb(${defaultValue.r}, ${defaultValue.g}, ${defaultValue.b})`,
          width: '28px',
          height: '28px',
          borderRadius: '8px',
          border: '3px solid #fff',
          boxShadow:
            '0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1)',
          cursor: 'pointer',
        }}
        onClick={handleClick}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            sx: {
              background: 'transparent',
              overflow: 'visible',
            },
          },
        }}
      >
        <ColorRGBControl {...controlProps} />
      </Popover>
    </div>
  );
};

ColorRGBControlWrapper.propTypes = actuatorControlPropTypes;
ColorRGBControl.propTypes = actuatorControlPropTypes;

export default ColorRGBControlWrapper;
